
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemaps/[year]/[month]",
      function () {
        return require("private-next-pages/sitemaps/[year]/[month]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemaps/[year]/[month]"])
      });
    }
  